module.exports = __webpack_public_path__ + "img/educacao2.2ac15c9e.svg";